import React from "react";
import LandingFooter from "../../pages/LandingPage/components/Footer";

const Footer = () => {
  return (
    <React.Fragment>
      <LandingFooter />
    </React.Fragment>
  );
};

export default Footer;
